import { Button, Container, Paper, Stack, Text, Title } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default function HotelPaymentSuccessPage() {
    const navigate = useNavigate();

    return (
        <Container size="sm" py="xl">
            <Paper withBorder radius="lg" p="xl">
                <Stack align="center" gap="md">
                    <IconCheck size={54} color="green" />

                    <Title order={2}>Payment received</Title>

                    <Text c="dimmed" ta="center">
                        Thank you. Your payment has been completed.
                        Your booking will now be updated automatically.
                    </Text>

                    <Button onClick={() => navigate("/")}>
                        Back to frontpage
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}